import React from 'react'
import {
  StructuredSearchTextLabelStyled,
  StructuredSearchTextLabelFontSize,
} from './StructuredSearchTextLabelStyled.styles'

interface StructuredSearchTextLabelProps {
  children: React.ReactNode
  size?: StructuredSearchTextLabelFontSize
}

export const StructuredSearchTextLabel = ({ children, size }: StructuredSearchTextLabelProps) => {
  return <StructuredSearchTextLabelStyled size={size}>{children}</StructuredSearchTextLabelStyled>
}
